import React, { useState } from "react";
import { GiCancel } from "react-icons/gi";
import { FiSave } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  recommend,
  handleCancelClick,
  increment,
  counter,
  setRecommendId,
}) => {
  const [newRecommend, setNewRecommend] = useState(recommend);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewRecommend((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "recommend/" + newRecommend.id + "/",
          newRecommend,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setRecommendId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };
  return (
    <tr>
      <td>
        <input
          type="text"
          name="first_name"
          className="form-control"
          id="first_name"
          value={newRecommend.first_name}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="last_name"
          className="form-control"
          id="last_name"
          value={newRecommend.last_name}
          placeholder=""
          onChange={handleChange}
        />
      </td>

      <td>
        <input
          type="text"
          name="job"
          className="form-control"
          id="job"
          value={newRecommend.job}
          placeholder=""
          onChange={handleChange}
        />
      </td>

      <td>
        <input
          type="text"
          name="address"
          className="form-control"
          id="address"
          value={newRecommend.address}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="tel"
          className="form-control"
          id="tel"
          value={newRecommend.tel}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          <FiSave />
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          <GiCancel />
        </button>
      </td>
    </tr>
  );
};

export default Edit;
